__turbopack_context__.v({
  "root": "about-module-scss-module__KVv77G__root",
  "typography_style": "about-module-scss-module__KVv77G__typography_style",
});
